// imports
import { Link } from 'react-router-dom'

// styles
import './Cards.css'

// assets
import Margaritas from '../assets/margaritas.jpg'
import Rosas from '../assets/rosas.jpg'
import Almendro from '../assets/almendro.jpg'

export default function Cards() {
    return (
        <div className="cards">
            <Link className="card" to="mi_vision">
                <img src={Margaritas} alt=""/>
                <h1 className="texto_caja">Mi visión del Reiki</h1>
            </Link>
            <Link className="card" to="reiki">
                <img src={Rosas} alt=""/>
                <h1 className="texto_caja">Reiki</h1>
            </Link>
            <Link className="card" to="canalizacion">
                <img src={Almendro} alt=""/>
                <h1 className="texto_caja">Canalización</h1>
            </Link>
        </div>
    )
}
